<template>
  <div class="tableMask exam-intro">
    <div class="anList">
      <div class="antitle">
        <h3>特别提示</h3>
      </div>
      <div v-if="currentCourse&&currentCourse.examNeedUrl"
           class="anbody">
        <iframe scrolling="auto"
                frameborder="0"
                marginwidth="16"
                marginheight="16"
                :src="currentCourse.examNeedUrl"
                height="100%"
                width="100%" />
      </div>
      <div class="anfooter">
        <a href="javascript:void(0)"
           class="an"
           @click="toNext">继续</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExamStartPage',
  props: {
    currentCourse: {
      type: Object,
      default: () => {
        return {
          examNeedUrl: '',
        }
      },
    },
  },
  mounted() {
    //console.log('---', this.currentCourse)
  },
  methods: {
    toNext() {
      this.$emit('showExamPage', true)
    },
  },
}
</script>
<style lang="scss" scoped>
.exam-intro {
  top: 45px;
  background: #e5e9f5;
  .anList {
    width: 80%;
    height: 80%;
    padding: 0 0 82px;
    box-shadow: 0 0 10px 10px #dae0f0;
    .antitle {
      border-bottom: 1px solid #ddd;
      > h3 {
        text-align: center;
        margin-bottom: 0;
      }
    }
    .anbody {
      max-height: none;
      height: 80%;
      overflow-y: hidden;
    }
  }
}
</style>
